__turbopack_context__.v({
  "blinkTwice": "blog-mobile-module-scss-module__0-nqpG__blinkTwice",
  "blogCardMobile": "blog-mobile-module-scss-module__0-nqpG__blogCardMobile",
  "blogCardMobileBottom": "blog-mobile-module-scss-module__0-nqpG__blogCardMobileBottom",
  "blogCardMobileExcerpt": "blog-mobile-module-scss-module__0-nqpG__blogCardMobileExcerpt",
  "blogCardMobileMedia": "blog-mobile-module-scss-module__0-nqpG__blogCardMobileMedia",
  "blogCardMobileReadMore": "blog-mobile-module-scss-module__0-nqpG__blogCardMobileReadMore",
  "blogCardMobileTitle": "blog-mobile-module-scss-module__0-nqpG__blogCardMobileTitle",
  "blogCardMobileTitleStrip": "blog-mobile-module-scss-module__0-nqpG__blogCardMobileTitleStrip",
  "blogDetailMobile": "blog-mobile-module-scss-module__0-nqpG__blogDetailMobile",
  "blogDetailMobileContent": "blog-mobile-module-scss-module__0-nqpG__blogDetailMobileContent",
  "blogDetailMobileMedia": "blog-mobile-module-scss-module__0-nqpG__blogDetailMobileMedia",
  "blogDetailMobilePanel": "blog-mobile-module-scss-module__0-nqpG__blogDetailMobilePanel",
  "blogDetailMobileParagraph": "blog-mobile-module-scss-module__0-nqpG__blogDetailMobileParagraph",
  "blogDetailMobileTitle": "blog-mobile-module-scss-module__0-nqpG__blogDetailMobileTitle",
  "blogIndexMobile": "blog-mobile-module-scss-module__0-nqpG__blogIndexMobile",
  "blogIndexMobileHero": "blog-mobile-module-scss-module__0-nqpG__blogIndexMobileHero",
  "blogIndexMobileHeroIntro": "blog-mobile-module-scss-module__0-nqpG__blogIndexMobileHeroIntro",
  "blogIndexMobileHeroTitle": "blog-mobile-module-scss-module__0-nqpG__blogIndexMobileHeroTitle",
  "blogIndexMobileList": "blog-mobile-module-scss-module__0-nqpG__blogIndexMobileList",
  "blogMobileBreadcrumb": "blog-mobile-module-scss-module__0-nqpG__blogMobileBreadcrumb",
  "blogMobileBreadcrumbCurrent": "blog-mobile-module-scss-module__0-nqpG__blogMobileBreadcrumbCurrent",
  "collapseWindow": "blog-mobile-module-scss-module__0-nqpG__collapseWindow",
  "expandFromTopLeft": "blog-mobile-module-scss-module__0-nqpG__expandFromTopLeft",
  "expandWindow": "blog-mobile-module-scss-module__0-nqpG__expandWindow",
  "shrinkToTopLeft": "blog-mobile-module-scss-module__0-nqpG__shrinkToTopLeft",
});
